"use client";

import { Checkout24 } from "@/components/icons/Checkout";
import { AmountDot } from "@/components/ui/AmountDot";
import { IconButton } from "@/components/ui/IconButton";
import type { ComponentProps } from "react";
import { useCartItemCount } from "./hooks";

export const CartAmount = (props: ComponentProps<typeof IconButton>) => {
	const { data } = useCartItemCount();

	const label = data! > 0 ? `Cart with ${data} item${data! > 1 ? "s" : ""}` : "Cart (empty)";
	return (
		<IconButton {...props} aria-label={label}>
			{data ? (
				<AmountDot amount={data || 0}>
					<Checkout24 />
				</AmountDot>
			) : (
				<Checkout24 />
			)}
		</IconButton>
	);
};
